var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H30V30H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-376.722,2388.939l-4.947-4.947-4.947,4.947a1.107,1.107,0,0,1-1.553-.109,1.106,1.106,0,0,1-.109-1.552l4.947-4.948-4.947-4.947a1.106,1.106,0,0,1,.109-1.552,1.107,1.107,0,0,1,1.553-.109l4.947,4.947,4.947-4.947a1.107,1.107,0,0,1,1.553.109,1.106,1.106,0,0,1,.108,1.552l-4.947,4.947,4.947,4.948a1.106,1.106,0,0,1-.108,1.552,1.254,1.254,0,0,1-.876.379A.945.945,0,0,1-376.722,2388.939Z",
    transform: "translate(396.669 -2367.331)",
    fill: "#4b4b4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.a55b8d316538d1d39c92f008f4a203a7.svg";
export { ForwardRef as ReactComponent };